import {wait} from "./util";

const where_to_run_redorbit_purchase_events = [
    location.href.includes('/store/order/end'),
    /^\/store\/order\/\d+\/upn\/$/.test(location.pathname) // On UPN as well
]

export function redorbit() {
    // Do we run this at all
    if(!where_to_run_redorbit_purchase_events.some(x=> x)) return
    console.debug(`RedOrbit Final URL, running tests and scripts`);

    // Remove ro parameter from history, so we do not reload this accidentally
    const params = new URLSearchParams(window.location.search)
    if(params.get("ro") !== 'true') return
    params.delete("ro");
    window.history.replaceState({}, '', window.location.pathname);

    // Obtain order data
    var order
    try { order = JSON.parse(document.getElementById('delo_order_data').textContent)
    } catch { console.log('event_object gtag: Invalid order') }
    if(!order) return console.log('event_object all: No order (no ga or fb events for RedOrbit)')

    order = beefUpOrder(order)
    // console.log('event_object ORDER', order)

    const allowFB = window.Didomi.getUserConsentStatusForPurpose('third')
    if(allowFB) {
        console.debug(`RedOrbit Google: redorbit.js (allowed: ${allowFB})`)
        fbCustomPurchase(order)
        fbComplexPurchase(order)
    }

    const allowGoogle = window.Didomi.getUserConsentStatusForVendor('google')
    if(allowGoogle) {
        console.debug(`RedOrbit FB: redorbit.js (allowed: ${allowGoogle})`);
        googleCustomPurchase(order)
        googleComplexPurchase(order)
    }
}


function googleCustomPurchase (order) {
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}

    order.packages.forEach(p => {
        const payload = {
            product_type: p.purchase_type,
            [p.type === 'event' ? 'event_title' : 'publication_title']: p.package_name
        }
        console.log('event_object gtag custom_purchase:', payload);
        gtag('event', 'custom_purchase', payload);
    })
}

async function fbCustomPurchase (order) {
    if (typeof fbq !== 'function') {
        await wait(100)
        return fbCustomPurchase(order)
    }
    order.packages.forEach(p => {
        const payload = {
            product_type: p.purchase_type,
            [p.type === 'event' ? 'event_title' : 'publication_title']: p.package_name
        }
        console.log('event_object fbq custom_purchase:', payload);
        fbq('trackCustom', 'custom_purchase', payload);
    })
}

async function fbComplexPurchase (order) {
    if (typeof fbq !== 'function') {
        await wait(100)
        return fbComplexPurchase(order)
    }
    const payload = {
        content_type: 'product',
        content_ids: order.packages.map(p => p.package_id),
        currency: 'EUR',
        value: order.total.total_without_vat
    }
    console.log('event_object fbq purchase:', payload);
    fbq('track', 'Purchase', payload);
}

function googleComplexPurchase(order) {
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}

    const payload = {
        currency: 'EUR',
        transaction_id: order.invoice_id || order.proforma_id,
        value: order.total.total_without_vat,
        tax: Object.values(order.total.vat).map(x => x.vat).reduce((accumulator, current) => accumulator + current),
        payment_method: order.invoice_method,
        shipping: undefined,
        coupon: undefined,
        affiliation: undefined,
        items: order.packages.map(p => ({
            item_id: p.package_id,
            item_name: p.package_name,
            item_variant: undefined,
            item_brand: 'Delo',
            item_category: p.purchase_type,
            price: p._final_price_without_vat,
            discount: p._total_discount,
            quantity: 1,
            coupon: undefined,
            affiliation: undefined,
            package_contains: JSON.stringify(
                p._items.map(i => ({id: i.id, name: i.title}))
            )
        }))
    }

    console.log('event_object gtag purchase:', payload);
    gtag('event', 'purchase', payload);
}

/**
 * HELPERS
 */
function beefUpOrder(order) {
    // Augment package
    order.packages = order.packages.map(p => {
        p._final_price_without_vat = order.items.map(i => i.net_price_all).reduce((acc, curr) => acc + curr)
        p._total_vat = order.items.map(i => i.vat).reduce((acc, curr) => acc + curr)
        p._total_discount = order.items.map(i => i.discount).reduce((acc, curr) => acc + curr)
        p._items = order.items.filter(i => i.package_id == p.package_id)
        return p
    })
    // Calculate prices without vat and vat complete
    order.total.total_without_vat = order.total.total
    order.total.all_vat = 0
    order.packages. forEach(p => {
        order.total.total_without_vat = order.total.total_without_vat - p._total_vat
        order.total.all_vat = order.total.all_vat + p._total_vat
    })
    return order
}


/*
const EXAMPLE_ORDER = {
    "address": {
        "billing": true,
        "city": "",
        "company": "",
        "country": {
            "code": "SI",
            "eu": true,
            "name": "Slovenija"
        },
        "first_name": "Anonimni Kupec",
        "id": 49537,
        "last_name": "",
        "postal_code": null,
        "primary": true,
        "profile": 1537498,
        "reg": "",
        "street_1": "Brez Naslova",
        "street_2": "",
        "street_nr": "",
        "vat": "",
        "vat_taxable": false
    },
    "codes": [
        "DRZ1ELPR"
    ],
    "date": "2025-04-10 13:59:43",
    "invoice_date": "2025-04-10 13:59:43",
    "invoice_id": 951576,
    "invoice_method": "braintree",
    "invoice_id": 77114202,
    "invoice_reference": "SI00 77114202",
    "items": [
        {
            "amount": 1,
            "description": "Onaplus Digital letna naročnina",
            "discount": 0,
            "discount_percent": 0,
            "discount_total": 41.99,
            "id": 111,
            "net_price_all": 39.99,
            "package_id": 111,
            "package_name": "Onaplus Digital letna naročnina",
            "sku": "591-LETO",
            "tax_percent": 5,
            "title": "Onaplus Digital letna naročnina - OSNOVNI IZDELEK - OK",
            "total": 41.99,
            "unit_price": 39.9905,
            "unit_price_with_discount": 39.9905,
            "valid_days": 366,
            "vat": 2
        }
    ],
    "method": "braintree",
    "original_recurring_order": 1052312,
    "packages": [
        {
            "description": "41,99 € letno",
            "package_id": 111,
            "package_name": "Onaplus Digital letna naročnina"
        }
    ],
    "total": {
        "total": 41.99,
        "vat": {
            "5.0": {
                "net_price_all": 39.99,
                "tax_percent": 5,
                "vat": 2
            }
        }
    },
    "uid": 1537498
}


const ExAMPLE_PURCHASE = {
    currency: 'CURRENCY_CODE',
    transaction_id: 'TRANSACTION_ID',
    value: 'TRANSACTION_VALUE',
    tax: 'TRANSACTION_TAX',
    shipping: 'TRANSACTION_SHIPPING',
    coupon: 'TRANSACTION_COUPON_CODE',
    affiliation: 'TRANSACTION_AFFILIATION',
    payment_method: 'PAYMENT_METHOD',
    items: [
        {
            item_id: 'PRODUCT_ID',
            item_name: 'PRODUCT_NAME',
            item_variant: 'PRODUCT_VARIANT',
            item_brand: 'PRODUCT_BRAND',
            item_category: 'PRODUCT_CATEGORY_LVL_1',
            item_category2: 'PRODUCT_CATEGORY_LVL_2',
            item_category3: 'PRODUCT_CATEGORY_LVL_3',
            item_category4: 'PRODUCT_CATEGORY_LVL_4',
            item_category5: 'PRODUCT_CATEGORY_LVL_5',
            price: 'PRODUCT_PRICE',
            discount: 'PRODUCT_DISCOUNT',
            quantity: 'PRODUCT_QUANTITY',
            coupon: 'PRODUCT_COUPON_CODE',
            affiliation: 'PRODUCT_AFFILIATION',
            package_contains: 'PACKAGE PRODUCTS'
        }
    ]
}
*/
